document.addEventListener('cart:updated', (event) => {
  const cart = event.detail.cart;
  const envioGratisUmbral = 30000; // CLP
  const totalActual = cart.total_price / 100;

  const mensaje = document.getElementById('envioGratisMensaje');
  const barra = document.getElementById('envioGratisProgreso');
  const texto = document.getElementById('envioGratisTexto');

  if (!mensaje || !barra || !texto) return;

  const progreso = Math.min((totalActual / envioGratisUmbral) * 100, 100);
  barra.style.width = progreso + '%';

  if (totalActual >= envioGratisUmbral) {
    mensaje.querySelector('.envio-gratis-ok')?.classList.remove('hidden');
    mensaje.querySelector('.envio-gratis-pendiente')?.classList.add('hidden');
    texto.textContent = '¡Tu pedido califica para envío gratis!';
    texto.style.color = '#2D7A2D';
  } else {
    const faltante = envioGratisUmbral - totalActual;
    mensaje.querySelector('.envio-gratis-ok')?.classList.add('hidden');
    mensaje.querySelector('.envio-gratis-pendiente')?.classList.remove('hidden');
    mensaje.querySelector('.envio-gratis-pendiente strong').textContent = `$${faltante.toLocaleString('es-CL')}`;
    texto.textContent = 'Sigue agregando tus favoritos de Quokka 🩷';
    texto.style.color = '#666';
  }
});
